import React from 'react'

const CircularProgress = ({
  size = 40,
  thickness = 3.6,
  value = 0,
  variant = 'indeterminate',
  className = '',
  sx = {},
  ...props
}) => {
  const radius = (size - thickness) / 2
  const circumference = radius * 2 * Math.PI
  const strokeDasharray = circumference
  const strokeDashoffset =
    variant === 'determinate'
      ? circumference - (value / 100) * circumference
      : undefined

  const containerStyles = {
    display: 'inline-block',
    position: 'relative',
    width: size,
    height: size,
    ...sx
  }

  const svgStyles = {
    transform: 'rotate(-90deg)',
    width: size,
    height: size
  }

  const circleStyles = {
    stroke: 'currentColor',
    strokeWidth: thickness,
    fill: 'transparent',
    strokeLinecap: 'round'
  }

  if (variant === 'indeterminate') {
    return (
      <div className={className} style={containerStyles} {...props}>
        <svg style={svgStyles}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            style={{
              ...circleStyles,
              strokeDasharray: strokeDasharray,
              animation: 'circular-progress-spin 1.4s linear infinite'
            }}
          />
        </svg>
        <style>
          {`
            @keyframes circular-progress-spin {
              0% { stroke-dasharray: 1px, 200px; stroke-dashoffset: 0; }
              50% { stroke-dasharray: 100px, 200px; stroke-dashoffset: -15px; }
              100% { stroke-dasharray: 100px, 200px; stroke-dashoffset: -125px; }
            }
          `}
        </style>
      </div>
    )
  }

  return (
    <div className={className} style={containerStyles} {...props}>
      <svg style={svgStyles}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          style={{
            ...circleStyles,
            strokeDasharray: strokeDasharray,
            strokeDashoffset: strokeDashoffset,
            transition: 'stroke-dashoffset 0.35s cubic-bezier(0.4, 0, 0.2, 1)'
          }}
        />
      </svg>
    </div>
  )
}

export default CircularProgress
